import * as React from 'react';
import DataImage from '../../DataImage';
import {IFoodBanksProps} from '../../utils/models';
import makeSum from '../../../../utils/makeSum';
import image from '../../asset/13. Equipment.png';

const Equipment = ({submissions}: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={makeSum(submissions, 'total_number_of_warehouse_equipment')}
            text='Total number of equipment'
        />
    );
};

export default Equipment;
